@if (hasEntitlements) {
  <article class="margin-bottom indv-bob">
    @if (form) {
      <form [formGroup]="form">
        <!-- PRODUCER ONLY REPORTS  -->
        <!--Producer Report -->
        @if (content.producerReport.show && isUserAgent && agentHasACSIdValue) {
          <section class="reports-block">
            <h3>{{content.producerReport.title || 'PRODUCER BOOK OF BUSINESS'}}</h3>
            <hr />
            <div class="margin-top">
              {{content.producerReport.description1 || 'The Producer Book of Business Report supports the management
              of the
              members
              associated with a producer.'}}
            </div>
            <div class="margin-top text-center">
              {{content.producerReport.description2 || 'Confidential - For producer use only; not for public
              distribution.'}}
            </div>
            <div class="margin-bottom clearfix">
              <div class="pull-right">
                <label>
                  @if (lineOfBusiness === 'individual') {
                    <mat-checkbox formControlName="agentIncludeSsn">
                      {{content.producerReport.includeSsn.text || 'Include SSN'}}
                    </mat-checkbox>
                  }
                  @if (lineOfBusiness === 'medicare') {
                    <mat-checkbox formControlName="agentIncludeMbi">
                      {{content.producerReport.includeSsn.text || 'Include MBI'}}
                    </mat-checkbox>
                  }
                  <!--
                  <input name="content.producerReport.includeSsn.name" type="checkbox"
                    data-ng-model="agentBobIncludeSsn" data-ng-change="flipIncludeAgentSsn()">
                    {{content.producerReport.includeSsn.text || 'Include SSN'}} -->
                  </label>
                  <br>
                    <button mat-flat-button color="primary" class="pull-right" (click)="downloadProducerReport()">
                      {{content.producerReport.download || 'DOWNLOAD EXCEL'}}
                    </button>
                  </div>
                </div>
              </section>
            }
            <!--Agency Report -->
            @if (content.agencyReport.show && hasGeneralAgencyAdmin) {
              <section class="reports-block">
                <h3>{{content.agencyReport.title || 'AGENCY BOOK OF BUSINESS'}}</h3>
                <hr />
                <div class="margin-top">
                  {{content.agencyReport.description1 || 'The Agency Book of Business Report supports a single agency with
                  the management of producers and the members associated with the agency and their producers.'}}
                </div>
                <div class="margin-top text-center">
                  {{content.agencyReport.description2 || 'Confidential - For agency use only; not for public
                  distribution.'}}
                </div>
                <div class="margin-bottom clearfix">
                  <div class="pull-right">
                    <label>
                      @if (lineOfBusiness === 'individual') {
                        <mat-checkbox formControlName="agencyIncludeSsn">
                          {{content.agencyReport.includeSsn.text || 'Include SSN'}}
                        </mat-checkbox>
                      }
                      @if (lineOfBusiness === 'medicare') {
                        <mat-checkbox formControlName="agencyIncludeMbi">
                          {{content.agencyReport.includeMbi.text || 'Include MBI'}}
                        </mat-checkbox>
                      }
                      <!--
                      <input name="content.agencyReport.includeSsn.name" type="checkbox" data-ng-model="agencyIncludeSsn"
                        data-ng-change="flipIncludeAgencySsn()">
                        {{content.agencyReport.includeSsn.text || 'Include SSN'}} -->
                      </label>
                      <br>
                        <button mat-flat-button color="primary" class="pull-right" (click)="downloadAgencyReport('REGULAR')">
                          {{content.agencyReport.download || 'DOWNLOAD EXCEL'}}
                        </button>
                      </div>
                    </div>
                  </section>
                }
                <!-- AGENCY ADMIN/INTERNAL  COMPONENTS BELOW -->
                <!--Preferred Agency Report -->
                @if (content.agencyReport_preferred.show && agencyType === 'Preferred Agency' && hasGeneralAgencyAdmin) {
                  <section class="reports-block"
                    >
                    <h3>{{content.agencyReport_preferred.title || 'PREFERRED (PGA) OR GENERAL AGENCY BOOK OF BUSINESS'}}</h3>
                    <hr />
                    <div class="margin-top">
                      {{content.agencyReport_preferred.description1 || 'The Preferred (PGA) and General Agency Book of Business
                      Reports support reporting agencies who manage other agencies. This includes the management support of other
                      producers and members associated within each agency.Confidential - For agency use only; not for public
                      distribution.'}}
                    </div>
                    <!-- <div class="margin-top text-center">
                    {{content.agencyReport_preferred.description2 || 'Description 2'}}
                  </div> -->
                  <div class="margin-bottom clearfix">
                    <div class="pull-right">
                      <label>
                        @if (lineOfBusiness === 'individual') {
                          <mat-checkbox formControlName="agencyPreferredIncludeSsn">
                            {{content.agencyReport.includeSsn.text || 'Include SSN'}}
                          </mat-checkbox>
                        }
                        @if (lineOfBusiness === 'medicare') {
                          <mat-checkbox formControlName="agencyPreferredIncludeMbi">
                            {{content.agencyReport.includeMbi.text || 'Include MBI'}}
                          </mat-checkbox>
                        }
                      </label>
                      <br>
                        <button mat-flat-button color="primary" class="pull-right" (click)="downloadAgencyReport('PREFERRED')">
                          {{content.agencyReport.download || 'DOWNLOAD EXCEL'}}
                        </button>
                      </div>
                    </div>
                  </section>
                }
                <!--Standard Agency Report -->
                @if (content.agencyReport_standard.show && agencyType === 'Standard Agency' && hasGeneralAgencyAdmin) {
                  <section class="reports-block"
                    >
                    <h3>{{content.agencyReport_standard.title || 'REPORTING AGENCY BOOK OF BUSINESS'}}</h3>
                    <hr />
                    <div class="margin-top">
                      {{content.agencyReport_standard.description1 || 'The Reporting Agency Book of Business Report supports
                      agencies who manage other agencies. This includes the management support of other producers and members
                      associated within each agency. Note: If you do not have an agency currently reporting to you, this report
                      will match the Single Agency Book of Business.'}}
                    </div>
                    <!-- <div class="margin-top text-center">
                    {{content.agencyReport_standard.description2 || 'Description 2'}}
                  </div> -->
                  <div class="margin-bottom clearfix">
                    <div class="pull-right">
                      <label>
                        @if (lineOfBusiness === 'individual') {
                          <mat-checkbox formControlName="agencyStandardIncludeSsn">
                            {{content.agencyReport.includeSsn.text || 'Include SSN'}}
                          </mat-checkbox>
                        }
                        @if (lineOfBusiness === 'medicare') {
                          <mat-checkbox formControlName="agencyStandardIncludeMbi">
                            {{content.agencyReport.includeMbi.text || 'Include MBI'}}
                          </mat-checkbox>
                        }
                      </label>
                      <br>
                        <button mat-flat-button color="primary" class="pull-right" (click)="downloadAgencyReport('STANDARD')">
                          {{content.agencyReport.download || 'DOWNLOAD EXCEL'}}
                        </button>
                      </div>
                    </div>
                  </section>
                }
                <!--Producer Activity Report  -->
                @if (content.producerActivityReport.show && isUserAgent && !!selectedAgency?.agentACSId) {
                  <section class="reports-block"
                    >
                    <h3>{{content.producerActivityReport.title || 'PRODUCER ACTIVITY REPORT (PAR)'}}</h3>
                    <hr />
                    <div class="margin-top">
                      {{content.producerActivityReport.description1 || 'The Producer Activity Report supports the management
                      of members
                      associated with a
                      producer by showing the past 90 days of activity. This includes new plans, termed and changes to
                      existing policies along with an effective date and reason. This report also shows AOR changes along with
                      an effective date.'}}
                    </div>
                    <div class="margin-top text-center">
                      {{content.producerActivityReport.description2 || 'Confidential - For producer use only; not for public
                      distribution.'}}
                    </div>
                    <div class="margin-bottom clearfix">
                      <div class="pull-right">
                        <button mat-flat-button color="primary" class="pull-right" (click)="downloadPAR()">
                          {{content.producerActivityReport.download || 'DOWNLOAD EXCEL'}}
                        </button>
                      </div>
                    </div>
                  </section>
                }
                <!--ENROLLMENT STATUS Report  -->
                @if (lineOfBusiness === 'medicare' && content.enrollmentStatusReport.show) {
                  <section class="reports-block">
                    <h3>{{content.enrollmentStatusReport.title || 'ENROLLMENT STATUS REPORT'}}</h3>
                    <hr />
                    <div class="margin-top">
                      {{content.enrollmentStatusReport.description1 || 'The Enrollment Status Report lists the enrollment status
                      for all Medicare members a producer is the AOR for regardless of the method of enrollment submission'}}
                    </div>
                    <div class="margin-top text-center">
                      {{content.enrollmentStatusReport.description2 }}
                    </div>
                    <div class="margin-bottom clearfix">
                      <div class="pull-right">
                        <button mat-flat-button color="primary" class="pull-right" (click)="downloadESReport()">
                          {{content.enrollmentStatusReport.download || 'DOWNLOAD EXCEL'}}
                        </button>
                      </div>
                    </div>
                  </section>
                }
              </form>
            }
          </article>
        } @else {
          <div class="loading-container warning-message">
            {{ noEntitlementsMessage || 'Your currently selected agency does not have access to Medicare Reports. Try a
            different agency if available.'}}
          </div>
        }


